import moment, { MomentInput } from "moment";

export const getWeek = function (input: Date | MomentInput) {
  return moment(input).isoWeek();
};
